import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Dashboard from './Dashboard';
import VersionControl from './VersionControl';
import ProductionLine from './ProductionLine';
import './Dashboard.css';

function Navigation() {
  const location = useLocation();
  const { isProductionOnly } = useAuth();

  return (
    <nav className="app-navigation">
      {!isProductionOnly && (
        <>
          <Link
            to="/"
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            Dashboard
          </Link>
          <Link
            to="/versions"
            className={`nav-link ${location.pathname === '/versions' ? 'active' : ''}`}
          >
            Version Control
          </Link>
        </>
      )}
      <Link
        to="/production-line"
        className={`nav-link ${location.pathname === '/production-line' ? 'active' : ''}`}
      >
        Production Line
      </Link>
    </nav>
  );
}

// Accounts with role 'production' are restricted to the Production Line
// section only. Everyone else (admin/viewer/general access) sees everything.
function GeneralAccessRoute({ children }: { children: React.ReactElement }) {
  const { isProductionOnly } = useAuth();
  if (isProductionOnly) {
    return <Navigate to="/production-line" replace />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navigation />
          <Routes>
            <Route path="/" element={<GeneralAccessRoute><Dashboard /></GeneralAccessRoute>} />
            <Route path="/versions" element={<GeneralAccessRoute><VersionControl /></GeneralAccessRoute>} />
            <Route path="/production-line" element={<ProductionLine />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;